document.addEventListener('DOMContentLoaded', function(){
  var tabs = document.querySelectorAll('#gh .tb');
  if(!tabs.length) return;
  var panels = {
    desc: document.getElementById('gh-desc'),
    specs: document.getElementById('gh-specs'),
    finishes: document.getElementById('gh-finishes'),
    reviews: document.getElementById('gh-reviews'),
    dl: document.getElementById('gh-dl')
  };
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      tabs.forEach(function(t){ t.classList.remove('on'); });
      Object.keys(panels).forEach(function(k){ if(panels[k]) panels[k].classList.remove('on'); });
      tab.classList.add('on');
      var p = panels[tab.getAttribute('data-tab')];
      if(p) p.classList.add('on');
    });
  });
});
setTimeout(function(){ document.querySelectorAll('.product__media-wrapper').forEach(function(el){ el.style.minHeight = ''; }); }, 600);